import styled from "styled-components";

export const BarChartContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${({background}) => background ? background : 'rgba(254, 254, 254, 0.60)'};
  border: none;
  box-sizing: border-box;
  border-radius: 12px;
  padding:16px;
  ${'' /* width:50%; */}

  .heading{
    font-family: 'Lato';
    font-size: 18px;
    font-style: normal;
    color: #184A61;
    font-weight: 700;
    line-height: 24px;
    display: flex;
    align-items: center;
    .dropdown{
      display:flex;
      margin: auto 0 auto auto;
    }
  }

  .total-row{
    display:flex;
    align-items:center;
  }
  .border{
    width:1px;
    height:60px;
    background: #EFEFEF;
    margin: auto 16px;
  }
  .emoji-users{
    display:block;
    margin-right:44px;
    .emoji{
      height:24px;
      width: auto;
      justify-content: center;
      display: flex;
      >svg{
        width:24px;
        height:24px;
      }
    }
    .help{
      color: #184A61;
      text-align: center;
      font-family: Lato;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }
    .user{
      color: #184A61;
      text-align: center;
      font-family: Lato;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 133.333% */
    }
  }

  .total{
    color:  #184A61;
font-family: 'Lato';
font-size: 40px;
font-style: normal;
font-weight: 700;
line-height: 68px; 
  }

  .no-data{
    text-align: center; 
    margin-top: 20px; 
    color: rgb(24, 74, 97); 
    font-size: 16px; 
    display: flex; 
    ${'' /* justify-content: center;  */}
    align-items: center; 
    font-family: Lato;
  }

  .total-text{
    color:  #DCDCDC;
font-family: 'Lato';
font-size: 40px;
font-style: normal;
${'' /* font-weight: 700; */}
line-height: 68px;
margin-left: 10px;
  }
  .image{
    width:48px;
    height:48px;
    border-radius:50%;
    margin-right:12px;
    display:flex;
    align-items:center;
    justify-content:center;
    background:#CE98B3;
    >img{
      width:24px;
      height:24px;
    }
  }
  .average{
    margin-left:24px;
    .daily{
      display:flex;
      align-items:center;
      .round{
        width:8px;
        height:8px;
        border-radius:50%;
        display:flex;
        margin-right:4px;
        background: #CE98B3;
      }
      .value{
        font-family: Lato;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        color: #184A61;
      }
      .subtext{
        font-family: Lato;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        color: #DCDCDC;
        margin-left:4px;
      }
    }
  }

  .compare-row{
    display:flex;
    ${'' /* justify-content:start; */}
    align-items:center;
  }

  .plus{
    display:flex;
    justify-content:center;
    align-items:center;
    padding: 4px;
    border-radius: 200px;
    border: 1px solid  #75B084;
    background:  #418856;
    color:  #FEFEFE;
    font-family: 'Lato';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    .icon{
      padding:2px;
      display:flex;
    }
  }
  .minus{
    display:flex;
    justify-content:center;
    align-items:center;
    padding: 4px;
    border-radius: 200px;
    border: 1px solid  #C13D4D;
    background:  #C13D4D;
    color:  #FEFEFE;
    font-family: 'Lato';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    .icon{
      padding:2px;
      display:flex;
    }
  }
  .none{
    display:flex;
    justify-content:center;
    align-items:center;
    padding: 4px;
    border-radius: 200px;
    border: 1px solid  rgb(241,201,119);
    background:  rgb(241,201,119);
    color:  #FEFEFE;
    font-family: 'Lato';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    .icon{
      padding:2px;
      display:flex;
    }
  }

  .text{
    color:  #092F41;
text-align: center;
font-family: 'Lato';
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px; 
margin-left: 8px;


  }
`;

export const Border = styled.div`
 width: 100%;
 margin: 20px 0px;
 border-bottom: 1px solid #EFEFEF;
`;